define(function (require) {
    "use strict";

    var LE = require("app");
    var RevisionedModel = require("models/RevisionedModel");
    var AuthenticationTypeModelBuilder = require("manager-models/data-sources/integrations/authentication/AuthenticationTypeModelBuilder");
    var ApiResources = require("assets/data/apiResources.json");
    var NameUtility = require("utils/NameUtility");

    var TYPES = {
        OAUTH2_IMPLICIT: 1,
        OAUTH2_CODE: 2,
        LP_AUTH: 0
    };

    var KEYS = {
        ID: "id",
        NAME: "name",
        TYPE: "type",
        DELETED: "deleted",
        CONFIGURATION: "configuration"
    };

    var TYPES_LIST = [
        TYPES.OAUTH2_IMPLICIT,
        TYPES.OAUTH2_CODE,
        TYPES.LP_AUTH
    ];

    var URL_PARAMETERS = "&select=$all";

    var AuthenticationServerModel = {};
    LE.module("LEManager", function (LEManager, LE, Backbone, Marionette, $, _) {

        AuthenticationServerModel = RevisionedModel.extend({
            resource: ApiResources.AccountConfig.Connectors,
            defaults : {
                id: null,
                name: "",
                deleted: false,
                type: null,
                configuration: null
            },
            saveEnableValidation: {
                type: {
                    fn: function () {
                        if (_.isUndefined(this.authTypeModel)) {
                            return "error";
                        }
                    }
                }
            },
            validation:{
                type: [{
                    required: true,
                    fn: function () {
                        if (_.isUndefined(this.authTypeModel)) {
                            return "error";
                        }
                        else {
                            var authTypeErrors = this.authTypeModel.validate();
                            if (!_.isEmpty(authTypeErrors)) {
                                return "LEManager.manager.dataSources.authentication.server.authView.error";
                            }
                        }
                    }
                }]
            },
            name: "AuthenticationServerModel",

            initialize: function(options){
                RevisionedModel.prototype.initialize.call(this, options);
            },
            url: function(){
                var url = RevisionedModel.prototype.url.apply(this, arguments);
                url = url + URL_PARAMETERS;
                return url;
            },
            pullAuthTypeModelChanges: function () {
                return this.setAuthTypeConfiguration(this.authTypeModel.toJSON());
            },

            save: function (attrs, options) {
                //First pull changes to model
                this.pullAuthTypeModelChanges();

                //Then call original save that will do the automatic validate etc
                return RevisionedModel.prototype.save.call(this, attrs, options);
            },
            setAuthName: function(value, options){
                options = options || {};
                this.set(KEYS.NAME, value, options);
            },

            getAuthTypeConfiguration: function(){
                return this.get(KEYS.CONFIGURATION);
            },

            setAuthTypeConfiguration: function(value){
                this.unset(KEYS.CONFIGURATION, {silent:true});
                this.set(KEYS.CONFIGURATION, value);
            },

            getAuthType: function(){
                return this.get(KEYS.TYPE);
            },
            setAuthType: function(value){
                this.set(KEYS.TYPE, value);
            },
            isDefinedAuthTypeId: function(){
                var authTypeId = this.getAuthType();
                return !_.isNull(authTypeId);
            },

            populateAuthTypeModel: function(authTypeId, authTypeConfig, newAuth){
                var authTypeModel;
                if (_.isUndefined(authTypeId) || _.isUndefined(authTypeConfig) || _.isUndefined(newAuth)){
                    authTypeId = this.getAuthType();
                    authTypeConfig = this.getAuthTypeConfiguration();
                    newAuth = false;
                }
                authTypeModel = AuthenticationTypeModelBuilder.createModelByType(authTypeId, authTypeConfig);
                authTypeModel.setIsNewAuth(newAuth);
                this.setAuthTypeModel(authTypeModel);
            },

            setAuthTypeModel: function(model){
                if (this.authTypeModel) {
                    this.stopListening(this.authTypeModel);
                }
                this.authTypeModel = model ;
                if (this.authTypeModel) {
                    this.listenTo(this.authTypeModel, "change",
                        _.bind(function () {
                            //informs the view a change has been made in one of the model's attribute - save button state
                            this.trigger("change:authTypeModel");
                        }, this));
                }

                //informs the view that a new auth type has been selected
                this.trigger("change:authType");
            },
            getAuthTypeModel: function(){
                return this.authTypeModel ;
            },
            validateSaveEnabled: function () {
                this.originalValidation = this.validation;
                this.validation = this.saveEnableValidation;

                var enable = this.isValid();

                this.validation = this.originalValidation;

                return enable;
            },

            isDeleteAction: function(){
                return false; //Delete action is temporarly disabled until new PROD and UX final decision
                /*return this.isDefinedAuthTypeId() &&
                this.authTypeModel.isDeleteAction();*/
            },

            isUnauthModel: function() {
                return (_.isFunction(this.getAuthTypeModel().getAcrValues) && this.getAuthTypeModel().getAcrValues() && this.getAuthTypeModel().getAcrValues().length === 1 && this.getAuthTypeModel().getAcrValues()[0] === "0");
            }

        });
    });

    AuthenticationServerModel.KEYS = KEYS;
    AuthenticationServerModel.TYPES = TYPES;
    AuthenticationServerModel.TYPES_LIST = TYPES_LIST;

    return AuthenticationServerModel;
});
